import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import './App.css';
import Flags from './Flags';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Box';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import Typography from "@mui/material/Typography";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

import Button from '@mui/material/Button';

import ErrorPage from "./ErrorPage";
import LoadingPage from "./LoadingPage";
import ZoomScheduleModal from "./ZoomScheduleModal";
import RimanBanner from "./RimanBanner";

function Main() {
    const [checkingUsername, setCheckingUsername] = useState(true);
    const { username } = useParams();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [hostEmail, setHostEmail] = useState("");

    const [successOpen, setSuccessOpen] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");
    
    const [notFound, setNotFound] = useState(false);

    const [date, setDate] = useState(null);
    const [time, setTime] = useState(""); // "02:00PM" | "06:00PM" | "08:00PM"

    const handleTimeChange = (event, newTime) => {
      // ToggleButtonGroup sends null if user clicks the already-selected option
      // If you want "must have one selected", ignore null.
      if (newTime !== null) setTime(newTime);
    };

    const [toast, setToast] = useState({
      open: false,
      message: "",
      severity: "error", // "error" | "success" | "warning" | "info"
    });

    const showToast = (message, severity = "error") => {
      setToast({ open: true, message, severity });
    };

    const handleClose = () => setToast((t) => ({ ...t, open: false }));

    const isMobile =
      ("ontouchstart" in window || navigator.maxTouchPoints > 0) &&
      window.matchMedia("(max-width: 768px)").matches;

    // const handleClick = () => {
    //   if (!email.trim()) {
    //     showToast("Please enter your email address.", "error");
    //     return;
    //   }
    //   // Basic HTML5-style check
    //   const isValid = /^\S+@\S+\.\S+$/.test(email);
    //   if (!isValid) {
    //     showToast("Please enter a valid email address.", "error");
    //     return;
    //   }

    //   // You can send `email` to your backend here if needed

    //   window.open("https://www.startkbeauty.com", "_blank", "noopener,noreferrer");
    // };

    const awards = [
        { img: "/images/awards/1.png", title: "2022 KCAB Korea Consumer Appraisal Brand's No.1 Brand", sub1: "Organizer: Dong-A Ilbo" },
        { img: "/images/awards/2.png", title: "2022 Women Consumer's Choice Premium Brand Top Prize" },
        { img: "/images/awards/3.png", title: "2021 Women Consumer's Choice Premium Brand Top Prize", sub1: "[Skincare Product Category: INCELLDERM]", sub2: 'Host: Weekly Donga' },
        { img: "/images/awards/4.png", title: "2021 Korea Brand Power No.1 Functional Cosmetic - INCELLDERM", sub1: "Organizer:Korea Premium Brand Association" },
        { img: "/images/awards/5.png", title: "2021 Nation's Consumer Driven Brand Top Prize Functional Cosmetic - INCELLDERM", sub1: "Organizer: Dong-A Ilbo" },
        { img: "/images/awards/6.png", title: "2020 Korea Brand Power No.1", sub1: "Host: Korea Premium Brand Association" },
        { img: "/images/awards/7.png", title: "2020 Nation's Consumer Driven Nation's Consumer Driven Brand Top Prize", sub1: "Host: Dong-A Ilbo" },
        { img: "/images/awards/8.png", title: "2020 Korea Consumer Preference Brand Award Top Prize", sub1: "Host: Sports Seoul", sub2: "Organizer: Korea Media Research" },
        { img: "/images/awards/9.png", title: "2020 Women Consumer's Choice Premium Brand Top Prize", sub1: "Organizer: Hankyung Business Gvalley News" },
        { img: "/images/awards/10.png", title: "2019 Women Consumer's Choice Premium Brand Top Prize", sub1: "Organizer: Hankyung Business Gvalley News" },
        { img: "/images/awards/11.png", title: "2018 Women Consumer's Choice Premium Brand Top Prize", sub1: "Organizer: Hankyung Business Gvalley News" },
    ];

    const flags = [
        { src: "/images/flags/canada.jpg", alt: "Canada" },
        { src: "/images/flags/taiwan.jpg", alt: "Taiwan" },
        { src: "/images/flags/hongkong.jpg", alt: "Hongkong" },
        { src: "/images/flags/malaysia.jpg", alt: "Malaysia" },
        { src: "/images/flags/singapore.jpg", alt: "Singapore" },
        { src: "/images/flags/philippines.jpg", alt: "Philippines" },
        { src: "/images/flags/uk.jpg", alt: "United Kingdom" },
        { src: "/images/flags/japan.jpg", alt: "Japan" },
        { src: "/images/flags/south_korea.jpg", alt: "South Korea" }
    ];


    const submitEmail = async (e) => {
      e.preventDefault();

      if(email == ""){
        showToast("Please enter your email address.", "error");
        return;
      }

      const form = new FormData();
      form.append("email", email);

      try {
        setLoading(true);

        const res = await fetch("https://whyriman.net/api/save.php", {
          method: "POST",
          body: form,
        });

        const data = await res.json().catch(() => null);

        if (!res.ok || !data?.ok) {
          alert('Failed to save email address. Please try again later.')
          return;
        }
        setLoading(false);
        setEmail("");
        
        const url = "https://www.startkbeauty.com";
        //window.open("https://www.startkbeauty.com", "_blank", "noopener,noreferrer")
        if (isMobile) {
          window.location.assign(url); // same tab
        } else {
          window.open(url, "_blank", "noopener,noreferrer"); // new tab
        }
      
      } catch (err) {
        setLoading(false);
        // alert('Failed to save email address. Please try again later.')
        showToast("Failed to save email address. Please try again later.", "error");
      } finally {
        setLoading(false);
      }

    };

    const confirmSchedule = async() => {

      if (!date) {
        showToast("Please select a date.", "error");
        return;
      }

      if (!time) {
        showToast("Please select a time.", "error");
        return;
      }
      
      if (!email) {
        showToast("Please enter your email address.", "error");
        return;
      }

      try {
        setLoading(true);

        const payload = {
          hostEmail,
          date: date ? date.format("YYYY-MM-DD") : null,
          time,
          email,
          name,
        };

        const res = await fetch("https://whyriman.net/api/email.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        const data = await res.json();

        if (!res.ok || !data.ok) {
          throw new Error(data?.message || "Mailer error");
        }

        setSuccessMsg("A confirmation email has been sent.");
        setSuccessOpen(true);
        setLoading(false);
        setOpen(false)
        window.open("https://www.facebook.com/myrimanbeauty", "_blank", "noopener,noreferrer");

        // const data = await res.json().catch(() => null);

        // if (!res.ok || !data?.ok) {
        //   alert('Failed to save email address. Please try again later.')
        //   return;
        // }
        // setLoading(false);
        setEmail("");
        setName("");
        setDate(null);
        setTime("");
      
      } catch (err) {
        setLoading(false);
        //alert('Failed to save email address. Please try again later.')
        showToast("Failed to save email address. Please try again later.", "error");
      } finally {
        setLoading(false);
      }
      
      // alert(`You have scheduled a Zoom call on ${date.format("YYYY-MM-DD")} at ${time}. We will contact you at ${email} with the Zoom link.`);
      // setOpen(false);
    }

  function FullPageLoader() {
    return (
      <div className="page_loader" role="status" aria-live="polite" aria-busy="true">
        <div className="spinner" />
      </div>
    );
  }

  useEffect(() => {
    let cancelled = false;
    if(username === "404") return;

    (async () => {
      try {
        const res = await fetch("https://whyriman.net/api/checkpoint.php", {//"http://localhost/apitest/whyriman/checkpoint.php", "https://whyriman.net/api/checkpoint.php"
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams({ username }),
        });
        
        const response = await res.json();

        if (cancelled) return;

        if (res.status === 404) {
          setNotFound(true);
          setCheckingUsername(false);
          return;
          // navigate("/404", { replace: true });
          // return;
        }


        if (!res.ok) throw new Error("API error");

        setCheckingUsername(false);
        setHostEmail(response?.data?.email);
      } catch (e) {
        // optional: treat errors as 404 or show error UI
        // navigate("/404", { replace: true });
        setNotFound(true);
        setCheckingUsername(false);
      }
    })();

    return () => { cancelled = true; };
  }, [username, navigate]);

  if(checkingUsername) return <LoadingPage />;
  if (notFound) return <ErrorPage />;

  return (
    <div className="App">
      {loading && <FullPageLoader />}

      <div className="wrapper">
          <h1>"An Opportunity to Partner <br />
            with a Billion-Dollar Company"
          </h1>

          <h2>Take advantage of the booming KBeauty Revolution <br /> A Legitimate Business Opportunity to Build Real Income!</h2>

          <div className='seperator'></div>
          <div className='video_wrapper'>
            <iframe
              src={`https://www.youtube.com/embed/7AQOB71OELA?rel=0`}
              title="YouTube video player"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>

          <div className="countries_container">
            <h2>Open to 11 countries and counting...</h2>
            <div className="flags_wrapper">
              {/* {flags.map((a, idx) => (
                  <div className="flags_item" key={`g1-${idx}`}>
                      <img src={a.img} alt={a.title} />
                  </div>
              ))} */}
              <Flags images={flags} />
            </div>
          </div>
      </div>

      <div id="awards_section" className="awards_section">
        <div className="content_wrapper">
            <div className="awards_marquee">
            <div className="awards_track">
                <div className="awards_group">
                {awards.map((a, idx) => (
                    <div className="awards_item" key={`g1-${idx}`}>
                        <img src={a.img} alt={a.title} />
                        <h3>{a.title}</h3>
                        {
                            a.sub1 && <h4>{a.sub1}</h4>
                        }
                        {
                            a.sub2 && <h4>{a.sub2}</h4>
                        }
                    </div>
                ))}
                </div>

                <div className="awards_group" aria-hidden="true">
                {awards.map((a, idx) => (
                    <div className="awards_item" key={`g2-${idx}`}>
                        <img src={a.img} alt="" />
                        <h3>{a.title}</h3>
                        {
                            a.sub1 && <h4>{a.sub1}</h4>
                        }
                        {
                            a.sub2 && <h4>{a.sub2}</h4>
                        }
                    </div>
                ))}
                </div>
            </div>
            </div>
          </div>
        </div>

      {/* <div className='sub_header'>
          <h3>EXPERIENCE THE POWER OF RIMAN RITUALS</h3>
          <h4>No Need To Go To Korea - The #1 KBeauty Brand in Korea is now in the Philippines</h4>
      </div> */}

      <div className='sub_header'>
          <RimanBanner />
      </div>
      
      <div className='video_container'>
        <div className='video_wrapper'>
          <iframe
            src={`https://www.youtube.com/embed/6l5B6LLbEiM?rel=0`}
            title="YouTube video player"
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
        <div className='video_wrapper'>
            <iframe
              src={`https://www.youtube.com/embed/mj8eyjC0vE4?rel=0`}
              title="YouTube video player"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
      </div>
      
      <div className='sub_header2'>
          <h3>Position Yourself in the Rising of K-Beauty Economy</h3>
          <h4>Discover how entrepreneurs are partnering with a global skincare brand and building additional income streams.</h4>
      </div>

      {/* <div className='messageme_btn_wrapper'>
        <div>
          <form onSubmit={submitEmail} className='messageme_btn_content'>
            <input
              className="email_input"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button type="submit">
                Learn More
            </button>
          </form>
        </div>
      </div> */}

      
      <div className='zoom_btn_wrapper'>
        <div className='zoom_btn_content'>
          <button type="button" onClick={() => setOpen(true)}>
              Schedule a Zoom Call
          </button>
          
        </div>
      </div>

      <div className='footer_wrapper'>
          <div className='left'>
              Copyright - All Rights Reserved 2026  
          </div>
          <div className='right'>
              Queen Boss Society | King Boss Club
          </div>
      </div>

    <ZoomScheduleModal
      open={open}
      onClose={() => setOpen(false)}
      name={name}
      setName={setName}
      email={email}
      setEmail={setEmail}
      date={date}
      setDate={setDate}
      time={time}
      handleTimeChange={handleTimeChange}
      confirmSchedule={confirmSchedule}
    />

      <Dialog
        open={successOpen}
        onClose={() => setSuccessOpen(false)}
        PaperProps={{ sx: { borderRadius: 3, p: 0.5 } }}
      >
        <DialogTitle sx={{ pb: 0.5 }}>
          <Stack direction="row" sx={{ display: 'flex', gap: '10px', alignContent: "center", alignItems: "center", fontWeight: 600, paddingBottom: '10px' }}>
            <CheckCircleRoundedIcon color="success" sx={{ fontSize: 30 }} />
            <span style={{ color: "#000" }}>Request sent!</span>
          </Stack>
        </DialogTitle>

        <DialogContent sx={{ pt: 1 }}>
          <Typography>
            {successMsg || "We received your Zoom call request."}
          </Typography>
          <Typography sx={{ mt: 1.2, opacity: 0.8 }} variant="body2">
            We’ll email you the Zoom link and details soon.
          </Typography>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setSuccessOpen(false)} variant="contained">
            Okay
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={toast.open}
        autoHideDuration={3500}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={toast.severity} variant="filled">
          {toast.message}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default Main;
